Vendd.Scripts.load(function () {
    'use strict';

    var $formWrapper = $('.x-loyalty-coupon-wrapper');

    if ($formWrapper.length > 0) {
        InitCouponForm($formWrapper);
    }

    function InitCouponForm($formWrapper) {

        var formData, valOpts, coupon, cartLoyaltyCouponPartial = "cartLoyaltyCouponForm_A";
        var $stepOne, $stepTwo, $submitButtonWrapper, $cancelButtonWrapper, $errorWrapper, $errorMessage, $successMessage, attempts = 0, maxAttempts = -1;

        var $form = $formWrapper;
        var form = $form.get(0);


        form.bindHtml = function bind(html) {
            $form.html(html);

            $submitButtonWrapper = $('.form-btn-submit', $form);
            $cancelButtonWrapper = $('.form-btn-cancel', $form);
            $stepOne = $('div.step-one-content', $form);
            $stepTwo = $('div.step-two-content', $form);

            $errorWrapper = $('.code-error-wrapper', form);
            $errorMessage = $('.code-error-message', $errorWrapper);
            $successMessage = $('.success-message');

            var validationCode = form.getValidationCode();
            if (validationCode) {
                $('input[name="code"]', form).val(validationCode);
            }

            form.initForm();
        };

        form.bindFormData = function (mobile) {
            formData = {
                "code": $('input[name="code"]', form).val(),
                "mobile": mobile
            };

            valOpts = {
                code: {
                    required: 'code-required'
                }
            };

            $form.validationEngine(valOpts);
        };

        form.initForm = function (model) {
            if (model && model.SuccessfullySend) {
                notyf.success(model.SuccessfullySendText);

                $stepOne.hide();
                $stepTwo.show();
                form.activateSubmitButton();
                form.bindFormData(model.ValidationForm.Mobile);
            } else {
                form.bindFormData();
            }
        };

        /* Store coupon code for cancel after model change */
        form.getCouponCode = function () {
            return sessionStorage.getItem('SelectedCoupon');
        };

        form.setCouponCode = function (couponCode) {
            if (couponCode) {
                sessionStorage.setItem('SelectedCoupon', couponCode);
            }
        };

        form.removeCouponCode = function () {
            sessionStorage.removeItem('SelectedCoupon');
        };

        /* Store validation code for display */
        form.getValidationCode = function () {
            return sessionStorage.getItem('ValidationCode');
        };

        form.setValidationCode = function () {
            if (formData.code) {
                sessionStorage.setItem('ValidationCode', formData.code);
            }
        };

        form.removeValidationCode = function () {
            sessionStorage.removeItem('ValidationCode');
        };


        form.submitForm = function (cancel) {
            form.loading(true);

            if (cancel === true) {
                Vendd.MessageBus.publishAsync(form, new Vendd.Loyalty.Messages.ClearCoupon(form.getCouponCode()));
            } else {
                attempts++;

                formData.mobile = omitScriptTag(formData.mobile);
                formData.code = omitScriptTag(formData.code);

                Vendd.MessageBus.publishAsync(form, new Vendd.Loyalty.Messages.ValidateSmsCode(formData.mobile, formData.code));
            }
        };

        form.reloadCart = function () {
            Vendd.Cart.ClearClientModel();
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
        }

        form.activateSubmitButton = function () {
            $('input.js-submit', $submitButtonWrapper).prop("disabled", false);
        }

        form.show = function show() {
            $form.show();
        };

        form.hide = function show() {
            $form.hide();
        };

        form.reset = function() {
            form.removeCouponCode();
            form.removeValidationCode();
            form.reloadCart();
        };

        form.loading = function (loading) {
            if (loading) {
                $form.addClass('x-loading');
            } else {
                $form.removeClass('x-loading');
            }
        }
        
        $form.on('click', '.js-submit', function (e) {
            valOpts = $form.validationEngine();

            $form.validationEngine(valOpts);
            var rf = $form.data('validationEngine');

            var valid = rf.validate();

            if (valid) {
                form.submitForm();
            }
        });

        $form.on('click', '.js-cancel', function (e) {
            valOpts = $form.validationEngine();

            $form.validationEngine(valOpts);
            var rf = $form.data('validationEngine');

            var valid = rf.validate();

            if (valid) {
                $errorMessage.hide();
                $successMessage.hide();
                form.submitForm(true);
            }
        });

        $form.on('keyup', 'input[name]', function (e) {
            var $this = $(this);
            var fieldName = $this.attr('name');

            formData[fieldName] = $this.val();
            var rf = $form.data('validationEngine');
            rf.validate(fieldName);
        });


        $form.on('change', 'select[name]', function (e) {
            form.loading(true);

            var $this = $(this);
            coupon = $("option:selected", $this).val();

            if (coupon !== "" && coupon !== undefined) {
                Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.ValidateCouponAndSendSms(coupon));
            }
        });


        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.SendSmsSuccess, form, function (envelope) {
            var data = envelope.message.data;
            
            if (data.SuccessfullySend) {
                notyf.success(data.SuccessfullySendText);
                $stepOne.hide();
                $stepTwo.show();
                form.activateSubmitButton();

                if (data.ValidationForm.Mobile) {
                    formData.mobile = data.ValidationForm.Mobile;
                }
            }

            form.loading(false);
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.SendSmsFailure, form, function () {
            form.loading(false);
            notyf.error('Something went wrong');
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.ValidateSmsCodeSuccess, form, function (envelope) {
            var data = envelope.message.data;

            if (data.StatusCode === 200) {
                attempts = 0;
                form.setValidationCode();
                Vendd.MessageBus.publishAsync(form, new Vendd.Loyalty.Messages.ApplyCoupon(coupon));
            } else {

                if (maxAttempts > 0 && maxAttempts === attempts) {
                    attempts = 0;
                    notyf.error('You have exceeded the maximum number of Tries (' + maxAttempts + '). Please try again.');
                    form.reset();
                } else {
                    $errorMessage.text(data.ResponseMessage);
                    $errorMessage.show();
                    form.loading(false);
                }
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.ValidateSmsCodeFailure, form, function () {
            form.loading(false);
            notyf.error('Something went wrong : Code could not be validated');
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.ApplyCouponSuccess, form, function() {
            form.setCouponCode(coupon);
            form.reloadCart();
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.ApplyCouponFailure, form, function () {
            form.loading(false);
            notyf.error('Something went wrong : Code could apply coupon');
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.ClearCouponSuccess, form, function() {
            form.reset();
        });

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.ClearCouponFailure, form, function () {
            form.loading(false);
            notyf.error('Something went wrong : Clear coupon failed');
        });


        Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, form, function (envelope) {
            var model = envelope.message.data.Cart;

            if (model.LoyaltyCouponForm && !model.IsEmpty) {
                var html = Vendd.Handlebars.parse(cartLoyaltyCouponPartial, model.LoyaltyCouponForm);
                form.bindHtml(html);
                form.show();

                if (maxAttempts <= 0 || maxAttempts === undefined) {
                    maxAttempts = model.LoyaltyCouponForm.MaxAttempts;
                }

            } else {
                form.hide();
            }

            form.loading(false);
        });
    }

});